export class DateFormatConstants {
    static DMY = 'DD/MM/YYYY';
    static MDY = 'MM/DD/YYYY';
    static YMD = 'YYYY/MM/DD';
}
